/**
 * Fold a keyword's explanation into the control's own `title`.
 *
 * This used to live beside `HintBadge`, a grey "?" with its own hover tooltip. The badge
 * is gone: hovering the keyword already showed `name — hint`, so the badge was a 3.5px
 * target revealing a subset of what the whole pill revealed. It also carried an awkward
 * constraint — it rendered inside a `<button>` on the facet chips, so it had to be an
 * inert, aria-hidden `<span>` to avoid nesting a focusable control in a button, which
 * meant it never worked for keyboard or assistive tech in the first place.
 *
 * So the delivery that was the fallback is now the only one, and it is the better one: it
 * covers the entire control, and screen readers and touch users get it too.
 *
 * Returns the base text unchanged when there is no hint, so callers need no branch.
 */
export function hintTitle(base: string, hint?: string | null): string {
  return hint ? `${base} — ${hint}` : base;
}
